<div class="tr md-no-proxy hover layout-row layout-align-start-center">

  <!--Select-->
  <div class="td col-id layout-row layout-align-start-center">
    <app-bringoz-checkbox [isChecked]="isSelected"
                          (clickEvent)="onToggle.emit(!isSelected); $event.stopPropagation()">
    </app-bringoz-checkbox>
  </div>

  <!--Account-->
  <div *ngIf="showAccountColumn" class="td col-account layout-row layout-align-start-center">
    <app-demand-account-link *ngIf="visitConfiguration.accountReference"
                             [account]="visitConfiguration.accountReference"
                             [isAllowCopyButton]="true">

    </app-demand-account-link>
  </div>

  <!--Projection-->
  <div class="td col-projection text-ellipsis layout-row layout-align-start-center">
    <div class="layout-column">

      <div class="layout-row layout-align-start-center">
        <span class="br-body-2">{{ visitConfiguration.units || 0 }} {{ 'Units' | translate }}</span>
      </div>

      <div class="layout-row layout-align-start-center gap-5">
        <app-service-type-indication class="br-body-2"
                                     [serviceType]="visitConfiguration.serviceType"
                                     [isShort]="true">

        </app-service-type-indication>
        <span class="br-body-2">{{ visitConfiguration.id }}</span>
      </div>

    </div>
  </div>

  <!--Skills-->
  <div class="td col-skills layout-row layout-align-start-center">
    <app-bringoz-items-list-display [items]="visitConfiguration.skills" [maxItems]="2"></app-bringoz-items-list-display>
  </div>

  <!--Destination-->
  <div class="td col-destination layout-row layout-align-start-center">
    <span class="br-body-2 text-ellipsis">{{visitConfiguration.destination.location.address | bringozAddress}}</span>
  </div>

  <!--Frequency-->
  <div class="td col-frequency text-ellipsis layout-row layout-align-start-center">
    <div class="layout-column">
      <span class="br-body-2 capitalize">{{ 'RECURRING.RRule.' + visitConfiguration.schedule.freq | translate }}</span>
      <div ng-if="visitConfiguration.schedule.byWeekDay.length"
           layout="row" layout-align="start center" class="gap-5">
        <span class="br-body-2 font-weight-600"
              *ngFor="let dayKey of visitConfiguration.schedule.byWeekDay; let last = last">
          {{ 'DAY_NAMES_SHORTCUT.' + dayKey | translate }}{{ !last ? ', ' : '' }}
        </span>
      </div>
    </div>
  </div>

  <!--Time Window-->
  <div class="td col-time-window layout-row layout-align-start-center">
    <span class="br-body-2">{{ visitConfiguration.schedule | timeWindow }}</span>
  </div>

  <!--Start'-->
  <div class="td col-start text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2">{{ visitConfiguration.schedule | bringozFullDate: 'startRecurring' }}</span>
  </div>

  <!--Expiration-->
  <div class="td col-expiration text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2">{{ visitConfiguration.schedule | bringozFullDate: 'endRecurring' }}</span>
  </div>

  <!--Created-->
  <div class="td col-created-on text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{ visitConfiguration | bringozFullDate: 'createdAt' }}</span>
  </div>

  <!--Updated-->
  <div class="td col-updated-on text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{ visitConfiguration | bringozFullDate: 'updatedAt' }}</span>
  </div>

  <!--Actions-->
  <div class="td col-actions text-ellipsis layout-row layout-align-start-center gap-5">
    <bringoz-button aria-label="Edit"
                    *ngxPermissionsOnly="'schedulingProject.visitConfiguration.update'"
                    type="tertiary"
                    size="fit"
                    (onClick)="onEdit.emit()">
      <bringoz-icon iconName="edit-outline" size="sm"></bringoz-icon>
    </bringoz-button>
    <bringoz-button aria-label="Delete"
                    *ngxPermissionsOnly="'schedulingProject.visitConfiguration.delete'"
                    type="tertiary"
                    size="fit"
                    (onClick)="onDelete.emit()">
      <bringoz-icon iconName="trash" size="sm"></bringoz-icon>
    </bringoz-button>
  </div>

</div>
